import React, {CSSProperties, Fragment} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {WINDOW_MODE_TABLET_WIDTH} from 'consts'
import convertUnit from 'lib/unit'
import {Paragraph} from 'common/components'
import {TransactionDetailContentItemListMultiCreatorProps} from './TransactionDetailContentItemListMultiCreatorProps'
import TransactionDetailContentItemMultiCreator from './TransactionDetailContentItemMultiCreator'
import TransactionDetailPackageItemMultiCreator from './TransactionDetailPackageItemMultiCreator'

const StyledContentSection = styled.div<CSSProperties>`
  display: flex;
  width: ${({width}) => width};
  flex-direction: column;
  margin: 0 ${convertUnit(25)};
  @media (max-width: ${WINDOW_MODE_TABLET_WIDTH}px) {
    width: 100%;
    margin: 0;
  }
`

const StyledSeparator = styled.div`
  width: 100%;
  height: ${convertUnit(2)};
  background-color: ${({theme}) => theme.white_4};
  align-self: stretch;
  margin-bottom: ${convertUnit(12)};
`

export default function TransactionDetailContentItemListMultiCreator({
  mode,
  data,
  onClickItem,
  showDiscount,
  handleRenderEntryBottom,
  topElement,
}: TransactionDetailContentItemListMultiCreatorProps) {
  const {translate} = useTranslation()

  return (
    <StyledContentSection
      marginTop={mode !== 'website' ? convertUnit(50) : 0}
      width="50%">
      {topElement}
      <Paragraph fontWeight="bold" fontSize="xl">
        {translate('global:creators')}
      </Paragraph>
      {data.map((item, index) => {
        const {invoice_id, package: packageData = []} = item

        return (
          <>
            <Fragment key={invoice_id}>
              {packageData.length > 0 ? (
                <TransactionDetailPackageItemMultiCreator
                  invoice={item}
                  showDiscount={showDiscount}
                  onClickItem={() => onClickItem(item, index)}
                  itemFooter={
                    handleRenderEntryBottom ? (
                      handleRenderEntryBottom(item)
                    ) : (
                      <></>
                    )
                  }
                />
              ) : (
                <TransactionDetailContentItemMultiCreator
                  invoice={item}
                  showDiscount={showDiscount}
                  onClickItem={() => onClickItem(item, index)}
                  itemFooter={
                    handleRenderEntryBottom ? (
                      handleRenderEntryBottom(item)
                    ) : (
                      <></>
                    )
                  }
                />
              )}
            </Fragment>
            <StyledSeparator />
          </>
        )
      })}
    </StyledContentSection>
  )
}
